export function mbToBytes(mb: number): number {
  return mb * 1024 * 1024;
}

export function bytesToMb(bytes: number): number {
  return bytes / (1024 * 1024);
}
